import { addIssuesToRisk } from "../../../helpers/addIssuesToRisk";
import { clearRiskText } from "../../../helpers/clearRiskText";
import { addNoIpmMeasureImplemented } from "../../../helpers/addNoIpmMeasureImplemented";

export const applePestSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const aphids = { name: 'aphids', display: "Aphids" };
    const fruitTreeSpiderMite = { name: 'fruitTreeSpiderMite', display: "Fruit Tree Red Spider Mite" };
    const lepidopterousCaterpillars = { name: 'lepidopterousCaterpillars', display: "Lepidopterous caterpillars" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'BioprotectantsMacrobiological'.toLowerCase()) {
                    measureWithPests.measures = 'Bioprotectants Macrobiological'
                    const issuesInControl = [aphids, fruitTreeSpiderMite, lepidopterousCaterpillars];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'BiopesticidesMicrobial'.toLowerCase()) {
                    measureWithPests.measures = 'Biopesticides Microbial'
                    const issuesInControl = [aphids, fruitTreeSpiderMite, lepidopterousCaterpillars];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'BioprotectantsSemiochemical'.toLowerCase()) {
                    measureWithPests.measures = 'Bioprotectants Semiochemical'
                    const issuesInControl = [lepidopterousCaterpillars];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'HygieneAndPrevention'.toLowerCase()) {
                    measureWithPests.measures = 'Hygiene And Prevention'
                    const issuesInControl = [lepidopterousCaterpillars];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'NutrientManagement'.toLowerCase()) {
                    measureWithPests.measures = 'Biological control agents (macrobiological) / Natural enemies'
                    const issuesInControl = [aphids];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'PhysicalExclusion'.toLowerCase()) {
                    measureWithPests.measures = 'Physical Exclusion'
                    const issuesInControl = [aphids];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'CanopyManagement'.toLowerCase()) {
                    measureWithPests.measures = 'Canopy Management'
                    const issuesInControl = [aphids, lepidopterousCaterpillars];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'CompanionCropping'.toLowerCase()) {
                    measureWithPests.measures = 'Companion Cropping'
                    const issuesInControl = [aphids, fruitTreeSpiderMite, lepidopterousCaterpillars];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'VarietyChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Variety Choice'
                    const issuesInControl = [aphids, lepidopterousCaterpillars];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'SpatialSeparation'.toLowerCase()) {
                    measureWithPests.measures = 'Spatial Separation'
                    const issuesInControl = [lepidopterousCaterpillars];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [aphids, fruitTreeSpiderMite, lepidopterousCaterpillars]);
    return listOfMeasuresWithPests;
};

export const appleDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const appleScab = { name: 'appleScab', display: "Apple Scab" };
    const canker = { name: 'canker', display: "Canker" };
    const powderyMildew = { name: 'powderyMildew', display: "Powdery Mildew" };
    const replantDisease = { name: 'replantDisease', display: "Replant Disease" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'biostimulants'.toLowerCase()) {
                    measureWithPests.measures = 'Biostimulants & elicitors'
                    const issuesInControl = [canker, powderyMildew];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support, incl. monitoring and forecasting'
                    const issuesInControl = [appleScab, powderyMildew];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, rotation & break crops'
                    const issuesInControl = [appleScab, replantDisease];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nutrientManagement'.toLowerCase()) {
                    measureWithPests.measures = 'Nutrient Management'
                    const issuesInControl = [appleScab, canker, powderyMildew, replantDisease];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'organicAmendments'.toLowerCase()) {
                    measureWithPests.measures = 'Organic Amendments'
                    const issuesInControl = [replantDisease];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'canopyManagement'.toLowerCase()) {
                    measureWithPests.measures = 'Canopy Management'
                    const issuesInControl = [appleScab, canker, powderyMildew, replantDisease];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Select low-risk locations'
                    const issuesInControl = [canker, replantDisease];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietyChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Variety choice and rootstock'
                    const issuesInControl = [appleScab, powderyMildew];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'hygieneAndPrevention'.toLowerCase()) {
                    measureWithPests.measures = 'Hygiene and Prevention'
                    const issuesInControl = [canker];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [appleScab, canker, powderyMildew, replantDisease]);
    return listOfMeasuresWithPests;
};

export const appleWeedsSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const windBlownWeeds = { name: 'windBlownWeeds', display: "Wind Blown Weeds" };
    const tapRootBlwApple = { name: 'tapRootBlwApple', display: "Tap Root broad leaf weeds" };
    const fibrousRootBlwApple = { name: 'fibrousRootBlwApple', display: "Fibrous Root broad leaf weeds" };
    const couch = { name: 'couch', display: "Couch" };
    const docks = { name: 'docks', display: "Docks" };
    const creepingThistle = { name: 'creepingThistle', display: "Creeping Thistle" };
    const spearThistle = { name: 'spearThistle', display: "Spear Thistle" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'mowing'.toLowerCase()) {
                    measureWithPests.measures = 'Mowing/topping/crimping/rolling'
                    const issuesInControl = [windBlownWeeds, tapRootBlwApple, fibrousRootBlwApple, docks];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'hygiene'.toLowerCase()) {
                    measureWithPests.measures = 'Hygiene/prevention'
                    const issuesInControl = [windBlownWeeds, creepingThistle, spearThistle];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'harrowing'.toLowerCase()) {
                    measureWithPests.measures = 'Harrowing/mechanical weeding'
                    const issuesInControl = [windBlownWeeds, tapRootBlwApple, fibrousRootBlwApple, spearThistle];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'physicalMulches'.toLowerCase()) {
                    measureWithPests.measures = 'Physical Mulches'
                    const issuesInControl = [windBlownWeeds, tapRootBlwApple, fibrousRootBlwApple, docks, spearThistle];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'thermalWeedControl'.toLowerCase()) {
                    measureWithPests.measures = 'Thermal Weed Control'
                    const issuesInControl = [windBlownWeeds, tapRootBlwApple, fibrousRootBlwApple, docks, spearThistle];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'handPulling'.toLowerCase()) {
                    measureWithPests.measures = 'Hand pulling/cutting/digging'
                    const issuesInControl = [docks, spearThistle];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'spotTreatment'.toLowerCase()) {
                    measureWithPests.measures = 'Spot Treatment'
                    const issuesInControl = [couch, docks, creepingThistle, spearThistle];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [windBlownWeeds, tapRootBlwApple, fibrousRootBlwApple, couch, docks, creepingThistle, spearThistle]);
    return listOfMeasuresWithPests;
};

export const barleyDiseaseSummaryMeasures = (controlMeasures, listOfIssues, isWinter) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const brownRust = { name: 'brownRust', display: "Brown Rust" };
    const earBlight = { name: 'earBlight', display: "Ear Blight" };
    const eyespot = { name: 'eyespot', display: "Eyespot" };
    const leafAndGlumeBlotch = { name: 'leafAndGlumeBlotch', display: "Leaf And Glume Blotch" };
    const mildew = { name: 'mildew', display: "Mildew" };
    const ramularia = { name: 'ramularia', display: "Ramularia" };
    const seedBorneDiseases = { name: 'seedBorneDiseases', display: "Seed Borne Diseases" };
    const takeAll = { name: 'takeAll', display: "Take-All" };
    const yellowRust = { name: 'yellowRust', display: "Yellow Rust" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'controlVolunteers'.toLowerCase()) {
                    measureWithPests.measures = 'Control volunteers & weeds'
                    const issuesInControl = [
                        brownRust,
                        mildew,
                        seedBorneDiseases,
                        takeAll,
                        yellowRust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support (including thresholds)'
                    const issuesInControl = [
                        brownRust,
                        earBlight,
                        eyespot,
                        mildew,
                        yellowRust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, rotation & break crops'
                    const issuesInControl = [
                        eyespot,
                        leafAndGlumeBlotch,
                        takeAll,
                        yellowRust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'hygiene'.toLowerCase()) {
                    measureWithPests.measures = 'Hygiene'
                    const issuesInControl = [
                        seedBorneDiseases
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nutrientManagement'.toLowerCase()) {
                    measureWithPests.measures = 'Nutrient Management'
                    const issuesInControl = [
                        mildew,
                        takeAll,
                        yellowRust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'primaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Primary cultivations (crop residue burial)'
                    const issuesInControl = [
                        earBlight,
                        eyespot
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedTesting'.toLowerCase()) {
                    measureWithPests.measures = 'Seed Testing'
                    const issuesInControl = [
                        seedBorneDiseases
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedbedQuality'.toLowerCase()) {
                    measureWithPests.measures = 'Seedbed Quality'
                    const issuesInControl = [
                        takeAll,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Select low-risk locations'
                    const issuesInControl = [
                        eyespot,
                        yellowRust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'sowingDate'.toLowerCase()) {
                    measureWithPests.measures = 'Sowing Date'
                    const issuesInControl = [
                        earBlight,
                        eyespot,
                        ramularia,
                        seedBorneDiseases,
                        takeAll,
                        yellowRust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietalChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Varietal Choice'
                    const issuesInControl = [
                        brownRust,
                        earBlight,
                        eyespot,
                        mildew,
                        takeAll,
                        yellowRust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus,
        [brownRust, earBlight, eyespot, leafAndGlumeBlotch, mildew, ramularia, seedBorneDiseases, takeAll, yellowRust]);
    return listOfMeasuresWithPests;
};
export const springBarleyDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => barleyDiseaseSummaryMeasures(controlMeasures, listOfIssues, false)
export const winterBarleyDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => barleyDiseaseSummaryMeasures(controlMeasures, listOfIssues, true)

export const barleyPestSummaryMeasures = (controlMeasures, listOfIssues, isWinter) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const bydvVectors = { name: 'bydvVectors', display: "BYDV Vectors" };
    const fritFly = { name: 'fritFly', display: "Frit Fly" };
    const goutFly = { name: 'goutFly', display: "Gout Fly" };
    const leatherjackets = { name: 'leatherjackets', display: "Leatherjackets" };
    const saddleGallMidge = { name: 'saddleGallMidge', display: "Saddle Gall Midge" };
    const slugs = { name: 'slugs', display: "Slugs" };
    const wheatBulbFly = { name: 'wheatBulbFly', display: "Wheat Bulb Fly" };
    const wireworms = { name: 'wireworms', display: "Wireworms" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support (including thresholds)'
                    const issuesInControl = [
                        bydvVectors,
                        fritFly,
                        saddleGallMidge,
                        slugs,
                        wheatBulbFly
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, Rotation & break crops'
                    const issuesInControl = [
                        fritFly,
                        leatherjackets,
                        slugs,
                        wheatBulbFly,
                        wireworms
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'primaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Primary cultivations / Crop residue burial'
                    const issuesInControl = [
                        bydvVectors,
                        fritFly,
                        leatherjackets,
                        wireworms
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'rollingSoil'.toLowerCase()) {
                    measureWithPests.measures = 'Rolling soil post-planting'
                    const issuesInControl = [
                        slugs
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'secondaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Secondary cultivations / drilling method'
                    const issuesInControl = [
                        bydvVectors,
                        fritFly,
                        leatherjackets,
                        wireworms
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedRate'.toLowerCase()) {
                    measureWithPests.measures = 'Seed rate'
                    const issuesInControl = [
                        fritFly,
                        leatherjackets,
                        slugs,
                        wheatBulbFly
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedbedQuality'.toLowerCase()) {
                    measureWithPests.measures = 'Seedbed quality'
                    const issuesInControl = [
                        slugs,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Select low-risk locations'
                    const issuesInControl = [
                        fritFly,
                        goutFly,
                        leatherjackets,
                        wireworms
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'sowingDate'.toLowerCase()) {
                    measureWithPests.measures = 'Sowing date'
                    const issuesInControl = [
                        bydvVectors,
                        fritFly,
                        goutFly,
                        wheatBulbFly
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'spatialSeparation'.toLowerCase()) {
                    measureWithPests.measures = 'Spatial separation'
                    const issuesInControl = [
                        wheatBulbFly
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nonCroppedAreas'.toLowerCase()) {
                    measureWithPests.measures = 'In field non-cropped areas'
                    const issuesInControl = [
                        wireworms
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietalChoice'.toLowerCase() && isWinter) {
                    measureWithPests.measures = 'Varietal Choice'
                    const issuesInControl = [
                        wireworms
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus,
        [bydvVectors, fritFly, goutFly, leatherjackets, saddleGallMidge, slugs, wheatBulbFly, wireworms]);
    return listOfMeasuresWithPests;
};
export const springBarleyPestSummaryMeasures = (controlMeasures, listOfIssues) => barleyPestSummaryMeasures(controlMeasures, listOfIssues, false)
export const winterBarleyPestSummaryMeasures = (controlMeasures, listOfIssues) => barleyPestSummaryMeasures(controlMeasures, listOfIssues, true)

export const beansDiseaseSummaryMeasures = (controlMeasures, listOfIssues, isWinter) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const botrytis = { name: 'botrytis', display: "Botrytis" };
    const rust = { name: 'rust', display: "Rust" };
    const sclerotinia = { name: 'sclerotinia', display: "Sclerotinia" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, rotation & break crops'
                    const issuesInControl = [
                        sclerotinia
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nutrientManagement'.toLowerCase()) {
                    measureWithPests.measures = 'Nutrient management'
                    const issuesInControl = [
                        botrytis,
                        rust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'primaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Primary cultivations (crop residue burial)'
                    const issuesInControl = [
                        botrytis,
                        rust,
                        sclerotinia
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'controlVolunteersAndWeeds'.toLowerCase()) {
                    measureWithPests.measures = 'Control volunteers & weeds'
                    const issuesInControl = [
                        rust,
                        sclerotinia
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'microbialBioprotectants'.toLowerCase()) {
                    measureWithPests.measures = 'Microbial bioprotectants'
                    const issuesInControl = [
                        sclerotinia
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support, incl. monitoring'
                    const issuesInControl = [
                        sclerotinia
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietalChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Variety choice'
                    const issuesInControl = [
                        botrytis,
                        rust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [botrytis, rust, sclerotinia]);
    return listOfMeasuresWithPests;
};
export const springBeansDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => beansDiseaseSummaryMeasures(controlMeasures, listOfIssues, false)
export const winterBeansDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => beansDiseaseSummaryMeasures(controlMeasures, listOfIssues, true)

export const beansPestSummaryMeasures = (controlMeasures, listOfIssues, isWinter) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const beanWeevil = { name: 'beanWeevil', display: "Bean weevil" };
    const blackbeanAphid = { name: 'blackbeanAphid', display: "Black bean aphid" };
    const bruchidBeetle = { name: 'bruchidBeetle', display: "Bruchid beetle" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support, incl. monitoring'
                    const issuesInControl = [
                        beanWeevil,
                        blackbeanAphid,
                        bruchidBeetle
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Select low-risk locations'
                    const issuesInControl = [
                        bruchidBeetle
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'sowingDate'.toLowerCase()) {
                    measureWithPests.measures = 'Sowing or planting date'
                    const issuesInControl = [
                        beanWeevil,
                        blackbeanAphid,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'earlyHarvest'.toLowerCase()) {
                    measureWithPests.measures = 'Early harvest'
                    const issuesInControl = [
                        bruchidBeetle
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [beanWeevil, blackbeanAphid, bruchidBeetle]);
    return listOfMeasuresWithPests;
};
export const springBeansPestSummaryMeasures = (controlMeasures, listOfIssues) => beansPestSummaryMeasures(controlMeasures, listOfIssues, false)
export const winterBeansPestSummaryMeasures = (controlMeasures, listOfIssues) => beansPestSummaryMeasures(controlMeasures, listOfIssues, true)

export const brassicasDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const darkLeafSpot = { name: 'darkLeafSpot', display: "Dark leaf spot - Alternaria" };
    const downyMildew = { name: 'downyMildew', display: "Downy Mildew" };
    const lightLeafSpot = { name: 'lightLeafSpot', display: "Light leaf spot" };
    const ringspot = { name: 'ringspot', display: "Ringspot" };
    const xanthomonas = { name: 'xanthomonas', display: "Xanthomonas" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support, incl. monitoring'
                    const issuesInControl = [
                        darkLeafSpot,
                        downyMildew,
                        lightLeafSpot,
                        ringspot,
                        xanthomonas
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'earlyProductionUnderCropCovers'.toLowerCase()) {
                    measureWithPests.measures = 'Early production under crop covers'
                    const issuesInControl = [
                        downyMildew
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'soilManagement'.toLowerCase()) {
                    measureWithPests.measures = 'Soil management and good drainage'
                    const issuesInControl = [
                        darkLeafSpot,
                        downyMildew,
                        lightLeafSpot,
                        ringspot,
                        xanthomonas
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, rotation & break crops'
                    const issuesInControl = [
                        darkLeafSpot,
                        lightLeafSpot,
                        ringspot,
                        xanthomonas
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'hygiene'.toLowerCase()) {
                    measureWithPests.measures = 'Hygiene (particularly in propagation)'
                    const issuesInControl = [
                        downyMildew,
                        lightLeafSpot,
                        ringspot,
                        xanthomonas
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'precisionIrrigation'.toLowerCase()) {
                    measureWithPests.measures = 'Precision Irrigation'
                    const issuesInControl = [
                        darkLeafSpot,
                        xanthomonas
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedTesting'.toLowerCase()) {
                    measureWithPests.measures = 'Seed testing'
                    const issuesInControl = [
                        downyMildew,
                        ringspot,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Select low-risk locations'
                    const issuesInControl = [
                        darkLeafSpot,
                        downyMildew,
                        lightLeafSpot,
                        ringspot,
                        xanthomonas
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietyChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Variety choice'
                    const issuesInControl = [
                        downyMildew,
                        ringspot,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'controlVolunteers'.toLowerCase()) {
                    measureWithPests.measures = 'Control volunteers and weeds'
                    const issuesInControl = [
                        darkLeafSpot,
                        downyMildew,
                        lightLeafSpot,
                        ringspot,
                        xanthomonas
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'primaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Primary cultivations (crop residue burial)'
                    const issuesInControl = [
                        darkLeafSpot,
                        downyMildew,
                        lightLeafSpot,
                        ringspot,
                        xanthomonas
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [darkLeafSpot, downyMildew, lightLeafSpot, ringspot, xanthomonas]);
    return listOfMeasuresWithPests;
};

export const brassicasPestSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const aphids = { name: 'aphids', display: "Aphids" };
    const cabbageRootFly = { name: 'cabbageRootFly', display: "Cabbage root fly" };
    const caterpillars = { name: 'caterpillars', display: "Caterpillars" };
    const whiteFly = { name: 'whiteFly', display: "White Fly" };
    const slugs = { name: 'slugs', display: "Slugs" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Selecting low-risk locations'
                    const issuesInControl = [whiteFly];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'controlVolunteers'.toLowerCase()) {
                    measureWithPests.measures = 'Control volunteers and weeds'
                    const issuesInControl = [aphids];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedbedManagement'.toLowerCase()) {
                    measureWithPests.measures = 'Seed bed management'
                    const issuesInControl = [
                        aphids,
                        slugs];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nonCroppedAreas'.toLowerCase()) {
                    measureWithPests.measures = 'In field non-cropped areas'
                    const issuesInControl = [
                        aphids,
                        cabbageRootFly,
                        caterpillars,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'bioprotectantsMicrobial'.toLowerCase()) {
                    measureWithPests.measures = 'Bioprotectants Microbial'
                    const issuesInControl = [
                        caterpillars,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'bioprotectantsNaturalSubstances'.toLowerCase()) {
                    measureWithPests.measures = 'Bioprotectants natural substances'
                    const issuesInControl = [
                        aphids,
                        whiteFly,
                        slugs
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support, incl. monitoring'
                    const issuesInControl = [
                        aphids,
                        cabbageRootFly,
                        caterpillars,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'precisionIrrigation'.toLowerCase()) {
                    measureWithPests.measures = 'Precision irrigation'
                    const issuesInControl = [
                        cabbageRootFly,
                        caterpillars,
                        whiteFly,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'physicalExclusion'.toLowerCase()) {
                    measureWithPests.measures = 'Physical exclusion of pests'
                    const issuesInControl = [
                        aphids,
                        cabbageRootFly,
                        caterpillars,
                        whiteFly,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [aphids, cabbageRootFly, caterpillars, whiteFly, slugs]);
    return listOfMeasuresWithPests;
};

export const improvedGrasslandDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const leafBlotch = { name: 'leafBlotch', display: "Leaf Blotch" };
    const mildew = { name: 'mildew', display: "Mildew" };
    const crownRust = { name: 'crownRust', display: "Crown Rust" };
    const drechsleraLeafDisease = { name: 'drechsleraLeafDisease', display: "Drechslera Leaf Disease" };
    const virusDiseases = { name: 'virusDiseases', display: "Virus Diseases" };
    const cloverRot = { name: 'cloverRot', display: "Clover Rot" };
    const leafDiseases = { name: 'leafDiseases', display: "Leaf Diseases" };
    const verticilliumWilt = { name: 'verticilliumWilt', display: "Verticillium Wilt" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'ploughingInCropResidue'.toLowerCase()) {
                    measureWithPests.measures = 'Ploughing in crop residue'
                    const issuesInControl = [
                        leafBlotch,
                        mildew,
                        crownRust,
                        drechsleraLeafDisease,
                        cloverRot,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietalChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Varietal Choice'
                    const issuesInControl = [
                        leafBlotch,
                        mildew,
                        crownRust,
                        drechsleraLeafDisease,
                        virusDiseases,
                        verticilliumWilt
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'controlVolunteersAndWeeds'.toLowerCase()) {
                    measureWithPests.measures = 'Control Volunteers And Weeds'
                    const issuesInControl = [
                        leafBlotch,
                        mildew,
                        crownRust,
                        drechsleraLeafDisease,
                        virusDiseases
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nutrientManagement'.toLowerCase()) {
                    measureWithPests.measures = 'Nutrient Management'
                    const issuesInControl = [
                        leafBlotch,
                        mildew,
                        crownRust,
                        drechsleraLeafDisease,
                        virusDiseases,
                        cloverRot,
                        leafDiseases,
                        verticilliumWilt
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'regularGrazing'.toLowerCase()) {
                    measureWithPests.measures = 'Regular grazing of young material'
                    const issuesInControl = [
                        leafBlotch,
                        mildew,
                        crownRust,
                        drechsleraLeafDisease,
                        leafDiseases
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'earlyHarvest'.toLowerCase()) {
                    measureWithPests.measures = 'Harvest at first sign / early to reduce loss / spread'
                    const issuesInControl = [
                        leafBlotch,
                        mildew,
                        crownRust,
                        drechsleraLeafDisease,
                        virusDiseases,
                        leafDiseases,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'hygieneAndPrevention'.toLowerCase()) {
                    measureWithPests.measures = 'Hygiene And Prevention'
                    const issuesInControl = [
                        cloverRot,
                        verticilliumWilt
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus,
        [leafBlotch, mildew, crownRust, drechsleraLeafDisease, virusDiseases, cloverRot, leafDiseases, verticilliumWilt]);
    return listOfMeasuresWithPests;
};

export const improvedGrasslandPestSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const fritFly = { name: 'fritFly', display: "Frit Fly" };
    const leatherjackets = { name: 'leatherjackets', display: "Leatherjackets" };
    const wireworms = { name: 'wireworms', display: "Wireworms" };
    const slugs = { name: 'slugs', display: "Slugs" };
    const cloverWeevil = { name: 'cloverWeevil', display: "Clover Weevil" };
    const cloverStemNematode = { name: 'cloverStemNematode', display: "Clover stem nematode" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'longTermLeys'.toLowerCase()) {
                    measureWithPests.measures = 'Avoid following long-term leys'
                    const issuesInControl = [
                        fritFly,
                        leatherjackets,
                        wireworms,
                        slugs,
                        cloverWeevil,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'sowingDate'.toLowerCase()) {
                    measureWithPests.measures = 'Sowing date'
                    const issuesInControl = [
                        fritFly,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'extraCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Extra cultivations'
                    const issuesInControl = [
                        leatherjackets,
                        wireworms,
                        slugs,
                        cloverWeevil,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'larvaeCountsInSoil'.toLowerCase()) {
                    measureWithPests.measures = 'Larvae counts in soil'
                    const issuesInControl = [
                        leatherjackets,
                        wireworms,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'pestMonitoring'.toLowerCase()) {
                    measureWithPests.measures = 'Pest monitoring'
                    const issuesInControl = [
                        fritFly,
                        leatherjackets,
                        wireworms,
                        slugs,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'rollingSoilPostPlanting'.toLowerCase()) {
                    measureWithPests.measures = 'Rolling soil post-planting'
                    const issuesInControl = [
                        wireworms,
                        slugs,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'narrowStemmedGrasses'.toLowerCase()) {
                    measureWithPests.measures = 'Narrow stemmed grasses'
                    const issuesInControl = [
                        cloverStemNematode
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, rotation & break crops'
                    const issuesInControl = [
                        fritFly,
                        leatherjackets,
                        wireworms,
                        cloverStemNematode
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'hygieneAndPrevention'.toLowerCase()) {
                    measureWithPests.measures = 'Hygiene and prevention'
                    const issuesInControl = [
                        cloverStemNematode
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nutrientManagement'.toLowerCase()) {
                    measureWithPests.measures = 'Nutrient management'
                    const issuesInControl = [
                        fritFly,
                        leatherjackets,
                        wireworms,
                        slugs,
                        cloverWeevil,
                        cloverStemNematode
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [
        fritFly,
        leatherjackets,
        wireworms,
        slugs,
        cloverWeevil,
        cloverStemNematode]);
    return listOfMeasuresWithPests;
};

export const improvedGrasslandWeedsSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const ragwort = { name: 'ragwort', display: "Ragwort" };
    const creepingButtercup = { name: 'creepingButtercup', display: "Creeping Buttercup" };
    const commonNettle = { name: 'commonNettle', display: "Common Nettle" };
    const docks = { name: 'docks', display: "Docks" };
    const creepingThistle = { name: 'creepingThistle', display: "Creeping Thistle" };
    const rushes = { name: 'rushes', display: "Rushes" };
    const bracken = { name: 'bracken', display: "Bracken" };
    const gorse = { name: 'gorse', display: "Gorse" };
    const broadleaved = { name: 'broadleaved', display: "Annual broadleaved weeds" };
    const meadow = { name: 'meadow', display: "Annual meadow grass" };
    const spearThistle = { name: 'spearThistle', display: "Spear Thistle" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'rotation'.toLowerCase()) {
                    measureWithPests.measures = 'Rotation'
                    const issuesInControl = [
                        ragwort,
                        creepingButtercup,
                        commonNettle,
                        docks,
                        spearThistle,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'improveSoilCondition'.toLowerCase()) {
                    measureWithPests.measures = 'Improving Soil Condition'
                    const issuesInControl = [
                        creepingButtercup,
                        commonNettle,
                        rushes,
                        bracken,
                        gorse
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'staleSeedbed'.toLowerCase()) {
                    measureWithPests.measures = 'Stale Seedbed'
                    const issuesInControl = [
                        ragwort,
                        creepingButtercup,
                        commonNettle,
                        docks,
                        rushes,
                        bracken,
                        gorse,
                        broadleaved,
                        meadow,
                        spearThistle,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'hygiene'.toLowerCase()) {
                    measureWithPests.measures = 'Hygiene'
                    const issuesInControl = [
                        ragwort,
                        creepingButtercup,
                        commonNettle,
                        docks,
                        creepingThistle,
                        rushes,
                        spearThistle,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'mowing'.toLowerCase()) {
                    measureWithPests.measures = 'Mowing/topping/crimping/rolling'
                    const issuesInControl = [
                        docks,
                        rushes,
                        bracken,
                        gorse
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'handPulling'.toLowerCase()) {
                    measureWithPests.measures = 'Hand pulling/cutting/digging'
                    const issuesInControl = [
                        ragwort,
                        docks,
                        spearThistle,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'harrowing'.toLowerCase()) {
                    measureWithPests.measures = 'Harrowing/mechanical weeding'
                    const issuesInControl = [
                        creepingButtercup,
                        docks,
                        broadleaved,
                        spearThistle,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'ploughing'.toLowerCase()) {
                    measureWithPests.measures = 'Ploughing'
                    const issuesInControl = [
                        ragwort,
                        creepingButtercup,
                        commonNettle,
                        docks,
                        spearThistle,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedRate'.toLowerCase()) {
                    measureWithPests.measures = 'Increased seed rate'
                    const issuesInControl = [
                        ragwort,
                        creepingButtercup,
                        docks,
                        broadleaved,
                        meadow,
                        spearThistle,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'reSeeding'.toLowerCase()) {
                    measureWithPests.measures = 'Re-seeding'
                    const issuesInControl = [
                        ragwort,
                        creepingButtercup,
                        commonNettle,
                        docks,
                        rushes,
                        bracken,
                        gorse,
                        spearThistle,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'grazing'.toLowerCase()) {
                    measureWithPests.measures = 'Grazing'
                    const issuesInControl = [
                        ragwort,
                        creepingButtercup,
                        docks,
                        broadleaved,
                        meadow,
                        spearThistle,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'bioprotectans'.toLowerCase()) {
                    measureWithPests.measures = 'Botanical bioprotectants'
                    const issuesInControl = [
                        ragwort
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'spotTreatment'.toLowerCase()) {
                    measureWithPests.measures = 'Spot Treatment'
                    const issuesInControl = [
                        ragwort,
                        creepingButtercup,
                        commonNettle,
                        docks,
                        creepingThistle,
                        spearThistle,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'weedWiper'.toLowerCase()) {
                    measureWithPests.measures = 'Weed Wiper'
                    const issuesInControl = [
                        commonNettle,
                        creepingThistle
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [
        ragwort,
        creepingButtercup,
        commonNettle,
        docks,
        creepingThistle,
        rushes,
        bracken,
        gorse,
        broadleaved,
        meadow,
        spearThistle]);
    return listOfMeasuresWithPests;
};

export const maizeDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const eyespot = { name: 'eyespot', display: "Eyespot" };
    const fusarium = { name: 'fusarium', display: "Fusarium" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'fieldHistoryRotation'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, rotation & break crops'
                    const issuesInControl = [eyespot, fusarium];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'primaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Primary cultivations (crop residue burial)'
                    const issuesInControl = [eyespot, fusarium];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietyChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Variety choice'
                    const issuesInControl = [eyespot];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [eyespot, fusarium]);
    return listOfMeasuresWithPests;
};

export const maizePestSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const europeanCornBorer = { name: 'europeanCornBorer', display: "European Corn Borer" };
    const wireworm = { name: 'wireworm', display: "Wireworm" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'fieldHistoryRotation'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, rotation & break crops'
                    const issuesInControl = [europeanCornBorer];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedRate'.toLowerCase()) {
                    measureWithPests.measures = 'Seed rate'
                    const issuesInControl = [wireworm];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedbed'.toLowerCase()) {
                    measureWithPests.measures = 'Seedbed quality'
                    const issuesInControl = [wireworm];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Select low-risk locations'
                    const issuesInControl = [wireworm];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [europeanCornBorer, wireworm]);
    return listOfMeasuresWithPests;
};

export const oatsDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const earBlight = { name: 'earBlight', display: "Ear Blight" };
    const eyespot = { name: 'eyespot', display: "Eyespot" };
    const mildew = { name: 'mildew', display: "Mildew" };
    const seedBorneDiseases = { name: 'seedBorneDiseases', display: "Seed Borne Diseases" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'controlVolunteers'.toLowerCase()) {
                    measureWithPests.measures = 'Control volunteers & weeds'
                    const issuesInControl = [
                        mildew,
                        seedBorneDiseases
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support (including thresholds)'
                    const issuesInControl = [
                        earBlight,
                        eyespot,
                        mildew
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, rotation & break crops'
                    const issuesInControl = [
                        eyespot
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'hygiene'.toLowerCase()) {
                    measureWithPests.measures = 'Hygiene'
                    const issuesInControl = [
                        seedBorneDiseases
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nutrientManagement'.toLowerCase()) {
                    measureWithPests.measures = 'Nutrient Management'
                    const issuesInControl = [
                        mildew
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'primaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Primary cultivations (crop residue burial)'
                    const issuesInControl = [
                        earBlight,
                        eyespot
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedTesting'.toLowerCase()) {
                    measureWithPests.measures = 'Seed Testing'
                    const issuesInControl = [
                        seedBorneDiseases
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Select low-risk locations'
                    const issuesInControl = [
                        eyespot
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'sowingDate'.toLowerCase()) {
                    measureWithPests.measures = 'Sowing Date'
                    const issuesInControl = [
                        earBlight,
                        eyespot,
                        seedBorneDiseases
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietalChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Varietal Choice'
                    const issuesInControl = [
                        earBlight,
                        eyespot,
                        mildew
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [earBlight, eyespot, mildew, seedBorneDiseases]);
    return listOfMeasuresWithPests;
};
export const springOatsDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => oatsDiseaseSummaryMeasures(controlMeasures, listOfIssues, false)
export const winterOatsDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => oatsDiseaseSummaryMeasures(controlMeasures, listOfIssues, true)

export const oatsPestSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const bydvVectors = { name: 'bydvVectors', display: "BYDV Vectors" };
    const fritFly = { name: 'fritFly', display: "Frit Fly" };
    const leatherjackets = { name: 'leatherjackets', display: "Leatherjackets" };
    const slugs = { name: 'slugs', display: "Slugs" };
    const wireworms = { name: 'wireworms', display: "Wireworms" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support (including thresholds)'
                    const issuesInControl = [
                        bydvVectors,
                        fritFly,
                        slugs
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, Rotation & break crops'
                    const issuesInControl = [
                        fritFly,
                        leatherjackets,
                        slugs,
                        wireworms
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'primaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Primary cultivations / Crop residue burial'
                    const issuesInControl = [
                        bydvVectors,
                        fritFly,
                        leatherjackets,
                        wireworms
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'rollingSoil'.toLowerCase()) {
                    measureWithPests.measures = 'Rolling soil post-planting'
                    const issuesInControl = [
                        slugs
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'secondaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Secondary cultivations / drilling method'
                    const issuesInControl = [
                        bydvVectors,
                        fritFly,
                        leatherjackets,
                        wireworms
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedbedQuality'.toLowerCase()) {
                    measureWithPests.measures = 'Seedbed quality'
                    const issuesInControl = [
                        slugs
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'sowingDate'.toLowerCase()) {
                    measureWithPests.measures = 'Sowing date'
                    const issuesInControl = [
                        bydvVectors,
                        fritFly
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nonCroppedAreas'.toLowerCase()) {
                    measureWithPests.measures = 'In field non-cropped areas'
                    const issuesInControl = [
                        bydvVectors
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietalChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Varietal Choice'
                    const issuesInControl = [
                        bydvVectors
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [bydvVectors, fritFly, leatherjackets, slugs, wireworms]);
    return listOfMeasuresWithPests;
};
export const springOatsPestSummaryMeasures = (controlMeasures, listOfIssues) => oatsPestSummaryMeasures(controlMeasures, listOfIssues, false)
export const winterOatsPestSummaryMeasures = (controlMeasures, listOfIssues) => oatsPestSummaryMeasures(controlMeasures, listOfIssues, true)

export const oilseedRapeDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const clubroot = { name: 'clubroot', display: "Clubroot" };
    const lightLeafSpot = { name: 'lightLeafSpot', display: "Light Leaf Spot" };
    const phomaStemCanker = { name: 'phomaStemCanker', display: "Phoma Stem Canker" };
    const sclerotiniaStemRot = { name: 'sclerotiniaStemRot', display: "Sclerotinia StemRot" };
    const verticilliumStemStripe = { name: 'verticilliumStemStripe', display: "Verticillium Stem Stripe" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'controlVolunteers'.toLowerCase()) {
                    measureWithPests.measures = 'Control volunteers & weeds'
                    const issuesInControl = [
                        clubroot,
                        sclerotiniaStemRot
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support (incl. thresholds)'
                    const issuesInControl = [
                        lightLeafSpot,
                        phomaStemCanker,
                        sclerotiniaStemRot
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, Rotation & break crops'
                    const issuesInControl = [
                        clubroot,
                        lightLeafSpot,
                        phomaStemCanker,
                        sclerotiniaStemRot,
                        verticilliumStemStripe
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'goodDrainage'.toLowerCase()) {
                    measureWithPests.measures = 'Good Drainage'
                    const issuesInControl = [
                        clubroot
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'hygiene'.toLowerCase()) {
                    measureWithPests.measures = 'Hygiene and prevention'
                    const issuesInControl = [
                        clubroot,
                        verticilliumStemStripe
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lime'.toLowerCase()) {
                    measureWithPests.measures = 'Lime'
                    const issuesInControl = [
                        clubroot
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'primaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Primary cultivations / Crop residue burial'
                    const issuesInControl = [
                        lightLeafSpot,
                        phomaStemCanker,
                        sclerotiniaStemRot
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Select low-risk locations'
                    const issuesInControl = [
                        clubroot,
                        sclerotiniaStemRot,
                        verticilliumStemStripe
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'sowingDate'.toLowerCase()) {
                    measureWithPests.measures = 'Sowing Date'
                    const issuesInControl = [
                        clubroot,
                        lightLeafSpot,
                        phomaStemCanker,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'spatialSeparation'.toLowerCase()) {
                    measureWithPests.measures = 'Spatial Separation'
                    const issuesInControl = [
                        clubroot,
                        lightLeafSpot,
                        phomaStemCanker,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietalChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Varietal Choice'
                    const issuesInControl = [
                        clubroot,
                        lightLeafSpot,
                        phomaStemCanker,
                        verticilliumStemStripe
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus,
        [clubroot, lightLeafSpot, phomaStemCanker, sclerotiniaStemRot, verticilliumStemStripe]);
    return listOfMeasuresWithPests;
};

export const oilseedRapePestSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const brassicaPodMidge = { name: 'brassicaPodMidge', display: "Brassica Pod Midge" };
    const cabbageRootFly = { name: 'cabbageRootFly', display: "Cabbage Root Fly" };
    const cabbageSeedWeevil = { name: 'cabbageSeedWeevil', display: "Cabbage Seed Weevil" };
    const cabbageStemFleaBeetle = { name: 'cabbageStemFleaBeetle', display: "Cabbage Stem Flea Beetle" };
    const mealyCabbageAphid = { name: 'mealyCabbageAphid', display: "Mealy Cabbage Aphid" };
    const pollenBeetle = { name: 'pollenBeetle', display: "Pollen Beetle" };
    const slugs = { name: 'slugs', display: "Slugs" };
    const turnipSawfly = { name: 'turnipSawfly', display: "Turnip Sawfly" };
    const tuyvVectors = { name: 'tuyvVectors', display: "TuYV Vectors" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support (incl. thresholds)'
                    const issuesInControl = [
                        cabbageRootFly,
                        cabbageSeedWeevil,
                        cabbageStemFleaBeetle,
                        mealyCabbageAphid,
                        pollenBeetle,
                        slugs,
                        turnipSawfly,
                        tuyvVectors];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'defoliation'.toLowerCase()) {
                    measureWithPests.measures = 'Defoliation (incl. mowing and grazing)'
                    const issuesInControl = [
                        cabbageStemFleaBeetle
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'rollingSoil'.toLowerCase()) {
                    measureWithPests.measures = 'Rolling soil post-planting'
                    const issuesInControl = [
                        slugs
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedRate'.toLowerCase()) {
                    measureWithPests.measures = 'Seed rate'
                    const issuesInControl = [
                        cabbageStemFleaBeetle
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedbedQuality'.toLowerCase()) {
                    measureWithPests.measures = 'Seedbed quality'
                    const issuesInControl = [
                        cabbageStemFleaBeetle,
                        slugs,
                        turnipSawfly
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'sowingDate'.toLowerCase()) {
                    measureWithPests.measures = 'Sowing date'
                    const issuesInControl = [
                        cabbageRootFly,
                        cabbageStemFleaBeetle
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'spatialSeparation'.toLowerCase()) {
                    measureWithPests.measures = 'Spatial separation'
                    const issuesInControl = [
                        brassicaPodMidge
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'trapCrops'.toLowerCase()) {
                    measureWithPests.measures = 'Trap crops'
                    const issuesInControl = [
                        cabbageStemFleaBeetle,
                        pollenBeetle
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietalChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Varietal choice'
                    const issuesInControl = [
                        tuyvVectors
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nonCroppedAreas'.toLowerCase()) {
                    measureWithPests.measures = 'In field non-cropped areas'
                    const issuesInControl = [
                        tuyvVectors
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus,
        [brassicaPodMidge, cabbageRootFly, cabbageSeedWeevil, cabbageStemFleaBeetle, mealyCabbageAphid, pollenBeetle, slugs, turnipSawfly, tuyvVectors]);
    return listOfMeasuresWithPests;
};

export const peasDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const botrytis = { name: 'botrytis', display: "Botrytis" };
    const downyMildew = { name: 'downyMildew', display: "Downy Mildew" };
    const leafSpot = { name: 'leafSpot', display: "Leaf Spot" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, rotation & break crops'
                    const issuesInControl = [botrytis];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nutrientManagement'.toLowerCase()) {
                    measureWithPests.measures = 'Nutrient Management'
                    const issuesInControl = [botrytis, downyMildew];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'primaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Primary cultivations (crop residue burial)'
                    const issuesInControl = [botrytis, downyMildew, leafSpot];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedTesting'.toLowerCase()) {
                    measureWithPests.measures = 'Seed Testing'
                    const issuesInControl = [leafSpot];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietalChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Varietal Choice'
                    const issuesInControl = [botrytis, downyMildew, leafSpot];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [botrytis, downyMildew, leafSpot]);
    return listOfMeasuresWithPests;
};

export const peasPestSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const peaAphid = { name: 'peaAphid', display: "Pea Aphid" };
    const peaMoth = { name: 'peaMoth', display: "Pea Moth" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'bioprotectantsNaturalSubstances'.toLowerCase()) {
                    measureWithPests.measures = 'Bioprotectants natural substances'
                    const issuesInControl = [peaAphid];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'bioprotectantsSemiochemical'.toLowerCase()) {
                    measureWithPests.measures = 'Bioprotectants Semiochemical  '
                    const issuesInControl = [peaMoth];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support, incl. monitoring'
                    const issuesInControl = [peaAphid, peaMoth];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Select low-risk locations'
                    const issuesInControl = [peaAphid];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nonCroppedArea'.toLowerCase()) {
                    measureWithPests.measures = 'In field non-cropped areas'
                    const issuesInControl = [peaAphid, peaMoth];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [peaAphid, peaMoth]);
    return listOfMeasuresWithPests;
};

export const potatoesDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const blackDot = { name: 'blackDot', display: "Black Dot" };
    const blackleg = { name: 'blackleg', display: "Blackleg" };
    const commonScab = { name: 'commonScab', display: "Common Scab" };
    const dryRot = { name: 'dryRot', display: "Dry Rot" };
    const earlyBlight = { name: 'earlyBlight', display: "Early Blight" };
    const gangrene = { name: 'gangrene', display: "Gangrene" };
    const lateBlight = { name: 'lateBlight', display: "Late Blight" };
    const powderyScab = { name: 'powderyScab', display: "PowderyScab" };
    const silverScurf = { name: 'silverScurf', display: "Silver Scurf" };
    const stemCankerAndBlackScurf = { name: 'stemCankerAndBlackScurf', display: "Stem Canker And Black Scurf" };
    const storageDiseases = { name: 'storageDiseases', display: "Storage Diseases" };
    const viruses = { name: 'viruses', display: "Viruses (Soil Borne)" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'controlVolunteersAndWeeds'.toLowerCase()) {
                    measureWithPests.measures = 'Control volunteers & weeds'
                    const issuesInControl = [
                        blackDot,
                        blackleg,
                        commonScab,
                        gangrene,
                        lateBlight,
                        powderyScab,
                        silverScurf,
                        stemCankerAndBlackScurf,
                        viruses
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support (including thresholds)'
                    const issuesInControl = [
                        blackDot,
                        blackleg,
                        lateBlight,
                        powderyScab,
                        silverScurf,
                        stemCankerAndBlackScurf
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'appropriateHarvest'.toLowerCase()) {
                    measureWithPests.measures = 'Appropriate Harvest'
                    const issuesInControl = [
                        blackDot,
                        blackleg,
                        gangrene,
                        lateBlight,
                        silverScurf,
                        stemCankerAndBlackScurf
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, Rotation & break crops'
                    const issuesInControl = [
                        blackDot,
                        blackleg,
                        commonScab,
                        lateBlight,
                        powderyScab,
                        silverScurf,
                        stemCankerAndBlackScurf,
                        viruses
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'goodDrainage'.toLowerCase()) {
                    measureWithPests.measures = 'Good Drainage'
                    const issuesInControl = [
                        blackleg,
                        lateBlight,
                        powderyScab
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'hygiene'.toLowerCase()) {
                    measureWithPests.measures = 'Hygiene'
                    const issuesInControl = [
                        blackleg,
                        lateBlight,
                        powderyScab,
                        storageDiseases,
                        viruses
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nutrientManagement'.toLowerCase()) {
                    measureWithPests.measures = 'Nutrient Management'
                    const issuesInControl = [
                        lateBlight
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'primaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Primary cultivations (crop residue burial)'
                    const issuesInControl = [
                        blackDot,
                        commonScab,
                        lateBlight,
                        silverScurf,
                        stemCankerAndBlackScurf
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedTesting'.toLowerCase()) {
                    measureWithPests.measures = 'Seed Testing'
                    const issuesInControl = [
                        powderyScab
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedbedQuality'.toLowerCase()) {
                    measureWithPests.measures = 'Seedbed Quality'
                    const issuesInControl = [
                        blackDot,
                        blackleg,
                        commonScab,
                        lateBlight,
                        stemCankerAndBlackScurf
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Select low-risk locations'
                    const issuesInControl = [
                        lateBlight,
                        powderyScab
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'sowingDate'.toLowerCase()) {
                    measureWithPests.measures = 'Planting Date'
                    const issuesInControl = [
                        lateBlight,
                        stemCankerAndBlackScurf,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'spatialSeparation'.toLowerCase()) {
                    measureWithPests.measures = 'Spatial Separation'
                    const issuesInControl = [
                        lateBlight
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietalChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Varietal Choice'
                    const issuesInControl = [
                        blackDot,
                        commonScab,
                        earlyBlight,
                        lateBlight,
                        powderyScab,
                        storageDiseases,
                        viruses
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus,
        [blackDot, blackleg, commonScab, dryRot, earlyBlight, gangrene, lateBlight, powderyScab, silverScurf, stemCankerAndBlackScurf, storageDiseases, viruses]);
    return listOfMeasuresWithPests;
};

export const potatoesPestSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const cutworms = { name: 'cutworms', display: "Cutworms" };
    const flnAndSpraing = { name: 'flnAndSpraing', display: "FLN and Spraing" };
    const potatoCystNematode = { name: 'potatoCystNematode', display: "Potato Cyst Nematode" };
    const slugs = { name: 'slugs', display: "Slugs" };
    const aphidBorne = { name: 'aphidBorne', display: "Aphid Borne" };
    const wireworm = { name: 'wireworm', display: "Wireworm" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'biofumigation'.toLowerCase()) {
                    measureWithPests.measures = 'Biofumigation'
                    const issuesInControl = [
                        potatoCystNematode
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'controlledIrrigation'.toLowerCase()) {
                    measureWithPests.measures = 'Controlled irrigation'
                    const issuesInControl = [
                        cutworms
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'controlVolunteersAndWeeds'.toLowerCase()) {
                    measureWithPests.measures = 'Control volunteers & weeds'
                    const issuesInControl = [
                        cutworms,
                        potatoCystNematode,
                        aphidBorne
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support (including thresholds) '
                    const issuesInControl = [
                        cutworms,
                        flnAndSpraing,
                        potatoCystNematode,
                        slugs,
                        aphidBorne,
                        wireworm
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'earlyHarvest'.toLowerCase()) {
                    measureWithPests.measures = 'Early harvest'
                    const issuesInControl = [
                        cutworms,
                        slugs,
                        wireworm
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, Rotation & break crops'
                    const issuesInControl = [
                        flnAndSpraing,
                        potatoCystNematode,
                        slugs,
                        wireworm];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'hygiene'.toLowerCase()) {
                    measureWithPests.measures = 'Hygiene'
                    const issuesInControl = [
                        potatoCystNematode,
                        aphidBorne
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nonCroppedArea'.toLowerCase()) {
                    measureWithPests.measures = 'In field non-cropped areas'
                    const issuesInControl = [
                        aphidBorne
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'primaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Primary culitvations / Crop residue burial'
                    const issuesInControl = [
                        slugs,
                        wireworm
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'secondaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Secondary cultivations'
                    const issuesInControl = [
                        slugs
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedTesting'.toLowerCase()) {
                    measureWithPests.measures = 'Seed testing'
                    const issuesInControl = [
                        potatoCystNematode,
                        aphidBorne
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Select low-risk locations'
                    const issuesInControl = [
                        flnAndSpraing,
                        potatoCystNematode,
                        aphidBorne,
                        wireworm
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'spatialSeparation'.toLowerCase()) {
                    measureWithPests.measures = 'Spatial separation'
                    const issuesInControl = [
                        aphidBorne
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'trapCrops'.toLowerCase()) {
                    measureWithPests.measures = 'Trap crops'
                    const issuesInControl = [
                        potatoCystNematode
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietalChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Varietal Choice '
                    const issuesInControl = [
                        flnAndSpraing,
                        potatoCystNematode,
                        aphidBorne
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [cutworms, flnAndSpraing, potatoCystNematode, slugs, aphidBorne, wireworm]);
    return listOfMeasuresWithPests;
};

export const sugarBeetDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const cercospera = { name: 'cercospera', display: "Cercospera" };
    const mildew = { name: 'mildew', display: "Mildew" };
    const rhizoctonia = { name: 'rhizoctonia', display: "Rhizoctonia" };
    const rhizomania = { name: 'rhizomania', display: "Rhizomania" };
    const rust = { name: 'rust', display: "Rust" };
    const violetRootRot = { name: 'violetRootRot', display: "Violet Root Rot" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support, incl. monitoring'
                    const issuesInControl = [
                        cercospera,
                        rhizoctonia,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, rotation & break crops'
                    const issuesInControl = [
                        cercospera,
                        rhizoctonia,
                        violetRootRot
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'hygiene'.toLowerCase()) {
                    measureWithPests.measures = 'Hygiene and prevention'
                    const issuesInControl = [
                        cercospera,
                        rhizoctonia,
                        rhizomania,
                        violetRootRot
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Select low-risk locations'
                    const issuesInControl = [
                        rhizoctonia,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietyChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Variety Choice'
                    const issuesInControl = [
                        cercospera,
                        mildew,
                        rust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [cercospera, mildew, rhizoctonia, rhizomania, rust, violetRootRot]);
    return listOfMeasuresWithPests;
};

export const sugarBeetPestSummaryMeasures = (controlMeasures, listOfIssues) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const beetCystNematode = { name: 'beetCystNematode', display: "Beet cyst nematode" };
    const virusYellows = { name: 'virusYellows', display: "Virus Yellows (aphid transmitted)" };
    const wireworm = { name: 'wireworm', display: "Wireworm" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support, incl. monitoring'
                    const issuesInControl = [
                        virusYellows
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, rotation & break crops'
                    const issuesInControl = [
                        beetCystNematode
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'hygiene'.toLowerCase()) {
                    measureWithPests.measures = 'Hygiene and prevention'
                    const issuesInControl = [
                        virusYellows
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedRate'.toLowerCase()) {
                    measureWithPests.measures = 'Seed rate'
                    const issuesInControl = [
                        virusYellows
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Select low-risk locations'
                    const issuesInControl = [
                        wireworm
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietyChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Variety choice'
                    const issuesInControl = [
                        beetCystNematode
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'soilAnalysis'.toLowerCase()) {
                    measureWithPests.measures = 'Soil analysis for pests'
                    const issuesInControl = [
                        beetCystNematode
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nonCroppedAreas'.toLowerCase()) {
                    measureWithPests.measures = 'In field non-cropped areas'
                    const issuesInControl = [
                        virusYellows
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus, [beetCystNematode, virusYellows, wireworm]);
    return listOfMeasuresWithPests;
};

export const wheatDiseaseSummaryMeasures = (controlMeasures, listOfIssues, isWinter) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const brownRust = { name: 'brownRust', display: "Brown Rust" };
    const earBlight = { name: 'earBlight', display: "Ear Blight" };
    const eyespot = { name: 'eyespot', display: "Eyespot" };
    const leafAndGlumeBlotch = { name: 'leafAndGlumeBlotch', display: "Leaf And Glume Blotch" };
    const mildew = { name: 'mildew', display: "Mildew" };
    const seedBorneDiseases = { name: 'seedBorneDiseases', display: "Seed Borne Diseases" };
    const septoria = { name: 'septoria', display: "Septoria" };
    const takeAll = { name: 'takeAll', display: "Take-All" };
    const yellowRust = { name: 'yellowRust', display: "Yellow Rust" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };

                if (measure.toLowerCase() === ''.toLowerCase()) {
                    measureWithPests.measures = ''
                    const issuesInControl = [
                        brownRust,
                        earBlight,
                        eyespot,
                        leafAndGlumeBlotch,
                        mildew,
                        seedBorneDiseases,
                        septoria,
                        takeAll,
                        yellowRust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'controlVolunteers'.toLowerCase()) {
                    measureWithPests.measures = 'Control volunteers & weeds'
                    const issuesInControl = [
                        brownRust,
                        mildew,
                        seedBorneDiseases,
                        yellowRust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support (including thresholds)'
                    const issuesInControl = [
                        brownRust,
                        earBlight,
                        eyespot,
                        leafAndGlumeBlotch,
                        mildew,
                        septoria,
                        yellowRust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, rotation & break crops'
                    const issuesInControl = [
                        eyespot,
                        leafAndGlumeBlotch,
                        septoria,
                        takeAll,
                        yellowRust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'hygiene'.toLowerCase()) {
                    measureWithPests.measures = 'Hygiene'
                    const issuesInControl = [
                        seedBorneDiseases
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nutrientManagement'.toLowerCase()) {
                    measureWithPests.measures = 'Nutrient Management'
                    const issuesInControl = [
                        mildew,
                        septoria,
                        takeAll,
                        yellowRust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'primaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Primary cultivations (crop residue burial)'
                    const issuesInControl = [
                        earBlight,
                        eyespot
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedTesting'.toLowerCase()) {
                    measureWithPests.measures = 'Seed Testing'
                    const issuesInControl = [
                        seedBorneDiseases
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedbedQuality'.toLowerCase()) {
                    measureWithPests.measures = 'Seedbed Quality'
                    const issuesInControl = [
                        takeAll,
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Select low-risk locations'
                    const issuesInControl = [
                        eyespot,
                        yellowRust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'sowingDate'.toLowerCase()) {
                    measureWithPests.measures = 'Sowing Date';
                    let issuesInControl = [
                        earBlight,
                        eyespot,
                        seedBorneDiseases,
                        takeAll,
                        yellowRust];
                    if (isWinter) {
                        issuesInControl.push(septoria);
                    }
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                if (measure.toLowerCase() === 'varietalChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Varietal Choice';
                    const issuesInControl = [
                        brownRust,
                        earBlight,
                        eyespot,
                        mildew,
                        septoria,
                        takeAll,
                        yellowRust
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }

                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus,
        [brownRust, earBlight, eyespot, leafAndGlumeBlotch, mildew, seedBorneDiseases, septoria, takeAll, yellowRust]);
    return listOfMeasuresWithPests;
};
export const springWheatDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => wheatDiseaseSummaryMeasures(controlMeasures, listOfIssues, false)
export const winterWheatDiseaseSummaryMeasures = (controlMeasures, listOfIssues) => wheatDiseaseSummaryMeasures(controlMeasures, listOfIssues, true)

export const wheatPestSummaryMeasures = (controlMeasures, listOfIssues, isWinter) => {
    const inUseStatus = 'inUse';
    const futureUseStatus = 'futureUse';
    const notUseStatus = 'notUse';
    const listOfMeasuresWithPests = {
        inUse: [],
        futureUse: [],
        notUse: []
    };
    const bydvVectors = { name: 'bydvVectors', display: "BYDV Vectors" };
    const fritFly = { name: 'fritFly', display: "Frit Fly" };
    const goutFly = { name: 'goutFly', display: "Gout Fly" };
    const leatherjackets = { name: 'leatherjackets', display: "Leatherjackets" };
    const orangeWheatBlossomMidge = { name: 'orangeWheatBlossomMidge', display: "Orange Wheat Blossom Midge" };
    const saddleGallMidge = { name: 'saddleGallMidge', display: "Saddle Gall Midge" };
    const slugs = { name: 'slugs', display: "Slugs" };
    const wheatBulbFly = { name: 'wheatBulbFly', display: "Wheat Bulb Fly" };
    const wireworms = { name: 'wireworms', display: "Wireworms" };
    const yellowWheatBlossomMidge = { name: 'yellowWheatBlossomMidge', display: "Yellow Wheat Blossom Midge" };
    for (const measure in controlMeasures) {
        if (controlMeasures.hasOwnProperty(measure)) {
            const status = controlMeasures[measure] ? controlMeasures[measure].status : null;
            if (status === inUseStatus || status === futureUseStatus) {
                let measureWithPests = {
                    measures: '',
                    controlMeasures: 'Control Measures Selected',
                    significantRisk: '',
                    moderateRisk: '',
                    slightRisk: '',
                    pestKeys: '',
                    notes: controlMeasures[measure]?.notes ?? '',
                    efficacyOfPreviousUse: controlMeasures[measure]?.efficacyOfPreviousUse ?? ''
                };
                if (measure.toLowerCase() === 'decisionSupport'.toLowerCase()) {
                    measureWithPests.measures = 'Decision support (including thresholds)'
                    const issuesInControl = [
                        bydvVectors,
                        fritFly,
                        orangeWheatBlossomMidge,
                        saddleGallMidge,
                        slugs,
                        wheatBulbFly
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'fieldHistory'.toLowerCase()) {
                    measureWithPests.measures = 'Field history, Rotation & break crops'
                    const issuesInControl = [
                        fritFly,
                        leatherjackets,
                        orangeWheatBlossomMidge,
                        slugs,
                        wheatBulbFly,
                        wireworms,
                        yellowWheatBlossomMidge
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'primaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Primary cultivations / Crop residue burial'
                    const issuesInControl = [
                        bydvVectors,
                        fritFly,
                        leatherjackets,
                        yellowWheatBlossomMidge
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'rollingSoil'.toLowerCase()) {
                    measureWithPests.measures = 'Rolling soil post-planting'
                    const issuesInControl = [
                        slugs
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'secondaryCultivations'.toLowerCase()) {
                    measureWithPests.measures = 'Secondary cultivations / drilling method'
                    const issuesInControl = [
                        bydvVectors,
                        fritFly,
                        leatherjackets,
                        wireworms
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedRate'.toLowerCase()) {
                    measureWithPests.measures = 'Seed rate'
                    const issuesInControl = [
                        fritFly,
                        leatherjackets,
                        slugs,
                        wheatBulbFly
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'seedbedQuality'.toLowerCase()) {
                    measureWithPests.measures = 'Seedbed quality'
                    const issuesInControl = [
                        slugs
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'lowRiskLocations'.toLowerCase()) {
                    measureWithPests.measures = 'Select low-risk locations'
                    const issuesInControl = [
                        fritFly,
                        goutFly,
                        leatherjackets,
                        wireworms
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'sowingDate'.toLowerCase()) {
                    measureWithPests.measures = 'Sowing date'
                    const issuesInControl = [
                        bydvVectors,
                        fritFly,
                        goutFly,
                        wheatBulbFly
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'spatialSeparation'.toLowerCase()) {
                    measureWithPests.measures = 'Spatial separation'
                    const issuesInControl = [
                        orangeWheatBlossomMidge,
                        wheatBulbFly,
                        yellowWheatBlossomMidge
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'nonCroppedAreas'.toLowerCase()) {
                    measureWithPests.measures = 'In field non-cropped areas'
                    const issuesInControl = [
                        bydvVectors
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                if (measure.toLowerCase() === 'varietalChoice'.toLowerCase()) {
                    measureWithPests.measures = 'Varietal Choice'
                    const issuesInControl = [
                        bydvVectors,
                        orangeWheatBlossomMidge
                    ];
                    addIssuesToRisk(issuesInControl, listOfIssues, measureWithPests);
                }
                clearRiskText(measureWithPests);
                listOfMeasuresWithPests[status].push(measureWithPests);
            }
        }
    }
    addNoIpmMeasureImplemented(listOfIssues, listOfMeasuresWithPests, notUseStatus,
        [bydvVectors, fritFly, goutFly, leatherjackets, orangeWheatBlossomMidge, saddleGallMidge, slugs, wheatBulbFly, wireworms, yellowWheatBlossomMidge]);
    return listOfMeasuresWithPests;
};
export const springWheatPestSummaryMeasures = (controlMeasures, listOfIssues) => wheatPestSummaryMeasures(controlMeasures, listOfIssues, false)
export const winterWheatPestSummaryMeasures = (controlMeasures, listOfIssues) => wheatPestSummaryMeasures(controlMeasures, listOfIssues, true)

export const getPestSummaryHelperFunctionFromCropName = (cropName) => {

    switch (cropName) {
        case 'apple':
            return applePestSummaryMeasures
        case 'brassicas':
            return brassicasPestSummaryMeasures
        case 'improvedgrassland':
            return improvedGrasslandPestSummaryMeasures
        case 'maize':
            return maizePestSummaryMeasures
        case 'oilseedrape':
            return oilseedRapePestSummaryMeasures
        case 'peas':
            return peasPestSummaryMeasures
        case 'potatoes':
            return potatoesPestSummaryMeasures
        case 'sugarbeet':
            return sugarBeetPestSummaryMeasures
        case 'springbarley':
            return springBarleyPestSummaryMeasures
        case 'winterbarley':
            return barleyPestSummaryMeasures
        case 'springbeans':
            return springBeansPestSummaryMeasures
        case 'winterbeans':
            return beansPestSummaryMeasures
        case 'springoats':
            return springOatsPestSummaryMeasures
        case 'winteroats':
            return oatsPestSummaryMeasures
        case 'springwheat':
            return springWheatPestSummaryMeasures
        case 'winterwheat':
            return winterWheatPestSummaryMeasures
        default:
            return null;

    }

}

export const getDiseaseSummaryHelperFunctionFromCropName = (cropName) => {

    switch (cropName) {
        case 'apple':
            return appleDiseaseSummaryMeasures
        case 'brassicas':
            return brassicasDiseaseSummaryMeasures
        case 'improvedgrassland':
            return improvedGrasslandDiseaseSummaryMeasures
        case 'maize':
            return maizeDiseaseSummaryMeasures
        case 'oilseedrape':
            return oilseedRapeDiseaseSummaryMeasures
        case 'peas':
            return peasDiseaseSummaryMeasures
        case 'potatoes':
            return potatoesDiseaseSummaryMeasures
        case 'sugarbeet':
            return sugarBeetDiseaseSummaryMeasures
        case 'springbarley':
        case 'winterbarley':
            return barleyDiseaseSummaryMeasures
        case 'springbeans':
        case 'winterbeans':
            return beansDiseaseSummaryMeasures
        case 'springoats':
        case 'winteroats':
            return oatsDiseaseSummaryMeasures
        case 'springwheat':
        case 'winterwheat':
            return wheatDiseaseSummaryMeasures
        default:
            return null;

    }

}


export const getWeedsSummaryHelperFunctionFromCropName = (cropName) => {


    switch (cropName) {
        case 'apple':
            return appleWeedsSummaryMeasures
        case 'improvedgrassland':
            return improvedGrasslandWeedsSummaryMeasures
        default:
            return null;
    }

}


